import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ShareSequenceType = 'invite';

const initialState = {
  activeShareSequence: null as ShareSequenceType | null,
  hasSeenInvitePopup: false,
  hasSeenCrossplayPopup: false,
};

const { actions, reducer } = createSlice({
  name: 'social',

  initialState,

  reducers: {
    setActiveShareSequence: (
      social,
      { payload }: PayloadAction<ShareSequenceType | null>,
    ) => {
      social.activeShareSequence = payload;
    },

    setHasSeenInvitePopup: (social, { payload }: PayloadAction<boolean>) => {
      social.hasSeenInvitePopup = payload;
    },

    /**
     * We should show crossplay promo only once per session
     */
    setHasSeenCrossplayPopup: (social, { payload }: PayloadAction<boolean>) => {
      social.hasSeenCrossplayPopup = payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase('RESET_APP', () => initialState);
  },
});

export const socialActions = actions;
export default reducer;
